import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import { MasterService,FeecounterService,ClassroomService,InventoryService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-issue',
  templateUrl: './issue.component.html',
  styleUrls: ['./issue.component.scss'],
   providers:[MasterService,FeecounterService,ClassroomService,InventoryService]
})
export class IssueComponent implements OnInit {

   sections:any=[];
    classes:any=[];
    arrstudent:any=[];
    arritem:any=[];
    arrvocdet:any=[];
    attdata:any=[];
    objfsm:any={};
    objinfo:any={};
    arrcat:any=[];
    arrclasscat:any=[];
    colums:any=[]
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    fmodel1:any={clid:'0',secid:'0',accatid:'0',crid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrrechead:any=[];
    arrastype:any=[];
    arracchead:any=[];
    arrcol:any=[];
    accat:any=[];
    arrfeerech:any=[];
    objvhead:any={};
    objfcol:any={};
    objstu:any={};
    oprtype:any='';
    oprtype1:any='';
    tabledata: any = {};
    ttldfeamt=0;
    arrfeesum:any=[];
    showload='No';
    sertxt:any="";
    catid:any;
    clientcd='';
    selmember:any={};
    memberdetails:any=[];
    modalOptions:NgbModalOptions;
  
    modalOptions1:NgbModalOptions;
    private modalRef: NgbModalRef;
    private modalRef1: NgbModalRef;
    private modalRef2: NgbModalRef;
    objdet: any = {};
    recdetails:any=[];
    objdetacc:any={};
    objfeesh:any={};
    objmisc:any={};
    Modeot:any=[];
    
  
    constructor(private http: HttpClient,private aservice:FeecounterService,private iservice:InventoryService,private cservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { 
  
      
    }
  
  
    
    ngOnInit(): void {
    
      this.fmodel.dtfrm=this.mservice.getdatetoday();
      this.fmodel.dtto=this.mservice.getdatetoday();
     this.getstudentsdata("");
      // this.masmot();
      // this.mascourse();
      // this.masacccat();
  
    }
  
   
  
  
   
 
  
  
    getstudentsdata(sertxt) {
      this.iservice.getinvstusale(sertxt)
          .subscribe(
          resultArray => {
              console.log('bloodgp', resultArray);
              this.arrstudent = resultArray;
            
          },
          error => console.log("Error :: " + error)
          )
    }
 
  
    masclass() {
      this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
            //  this.classsort = resultArray.sort((a, b) => {
            //     if (a.clid > b.clid) {
            //       return -1;
            //     }
            //   });
             this.objmisc.clid=resultArray[0].clid;
              this.massection();
              
              
             
          },
          error => console.log("Error :: " + error)
          )
    }
  
  
    opencoldialog(content,objdata) {
     
        this.objdet=objdata;
        this.objdet.recdt=this.aservice.getdatetoday();
        //this.submodel.parentsubid=0;
        this.objdet.mor='CASH';
        this.objdet.cqno='';
        this.objdet.cqdt=this.aservice.getdatetoday();
        this.objdet.bknm='';
        this.objdet.ifsc='';
        this.objdet.RecAmt=objdata.BalAmt;
        console.log('recamt1',this.objdet.RecAmt);
       
        
  //this.getrecdetails(objdata);
  console.log('recamt2',this.objdet.RecAmt);
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        
       size:'lg'
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
    massection() {
      this.mservice.massection()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.objmisc.scid=resultArray[0].scid;
            
          },
          error => console.log("Error :: " + error)
          )
    }
  
    applyvocherFilter(filterValue: string) {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    
      if(filterValue.length>=3)
      {
        this.getstudentsdata(filterValue);
        // this.getrecdetails('serchvoch',filterValue,this.catid);
        
      
    }
    else 
    {
      this.getstudentsdata("");
    }
    
    }
  
    
  
    
  }
  
